import React from 'react'
import styled from 'styled-components'
import SkillCard from './SkillCard'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
        margin-bottom: 30px;
    }
    .cards {
        display: flex;
        gap: 15vw;
    }

    @media (max-width: 700px) {
        .cards {
            flex-direction: column;
        }
    }
`

// function SkillText (this: any, title?: string) {
//     this.title = title
// }
// const skill1 = new SkillText('Social Media')
// const skill2 = new SkillText('Designer')

interface Item {
    title: string
}

const redes1 = [['Instagram', '100%'], ['Facebook', '90%'], ['TikTok', '80%'], ['Linkedin', '70%']]
const skill1: Readonly<Item> = {
    title: 'Social Media'
}

const redes2 = [['Photoshop', '90%'], ['Ilustrator', '60%'], ['Premiere', '90%'], ['Canva', '100%']]
const skill2: Readonly<Item> = {
    title: 'Designer'
}

function Skills() {
  return (
      <Wrapper>
          <h2 id='skills'>Habilidades</h2>
          <div className='cards'>
            <SkillCard {...skill1} redes={redes1} />
            <SkillCard {...skill2} redes={redes2} />
          </div>
      </Wrapper>
  );
}

export default Skills;